import { makeStyles, Theme } from '@material-ui/core/styles';

const useStyles = makeStyles((theme: Theme) => ({
  buttons: {
    display: 'flex',
    justifyContent: 'space-between',
    margin: theme.spacing(2, 0, 2),
  },
}));

export default useStyles;
